'use strict';

/**
 * Filter component view
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var FilterComponentView = require('modules/base/views/layout/filter-component');
var template = require('modules/collection/templates/components/filter/locality.hbs');

var LocalityView = FilterComponentView.extend({
    template: template,

    ui: {
        'multipleOptions': '.component-filter-buttons input[type="checkbox"]',
    },

    events: {
        'change @ui.multipleOptions': 'change',
    },

    commonCountries: [],

    recentCountries: [
        {type: 5506, displayName: 'Tanzania'},
        {type: 5132, displayName: 'Belize'},
        {type: 5230, displayName: 'Guatemala'},
        {type: 5138, displayName: 'Bhutan'},
    ],

    specificLocalities: [
        {type: 1000945, displayName: 'Redsmit, UK'},
        {type: 1000901, displayName: 'Eagles Nest, US'},
        {type: 1000955, displayName: 'Broken Hill, Australia'},
        {type: 1000837, displayName: 'Sweet Home Mine, US'},
    ],

    viewData: {
        commonCountries: function() {
            return this.commonCountries.concat([{type: 'undefined', displayName: 'unknown'}]);
        },
        recentCountries: function() {
            return this.recentCountries;
        },
        specificLocalities: function() {
            return this.specificLocalities;
        },
    },

    initialize: function(options) {
        FilterComponentView.prototype.initialize.apply(this, arguments);

        this.commonCountries = this.getCommonValues(5);
    },

    getFilters: function() {
        var filters = [];

        var multipleOptions = this.ui.multipleOptions.filter(':checked');

        multipleOptions.each(function(index, option){
            option = $(option);
            filters.push({value: option.val(), displayName: option.next('label').text().trim()});
        });

        return filters;
    },

    setFilters: function(filters) {
        filters = filters.split(',');

        this.ui.multipleOptions.each(function(index, option){
            $(option).prop('checked', _.contains(filters, $(option).val()));
        });
    },

    resetFilters: function() {
        this.ui.multipleOptions.each(function(index, option){
            $(option).prop('checked', false);
        });

        this.change();
    },

    getSortedValues: function() {
        if (!this.sortedValues) {
            var sortedValues = {};

            this.collection.each(function(model){
                var countryId = _.result(model.get('localities'), 'country');

                if (countryId) {
                    if (sortedValues[countryId]) {
                        sortedValues[countryId].count++
                    } else {
                        sortedValues[countryId] = {
                            count: 1,
                            type: countryId,
                            displayName: 'localitiyName-for-' + countryId, //@todo with V2
                        }
                    }
                }
            });

            this.sortedValues = _.sortBy(sortedValues, function(item) { return item.count * -1; });
        }

        return this.sortedValues;
    },

    getFilterValueDisplayName: function(value) {
        // var values = this.getSortedValues();
        // var species = _.findWhere(values, {type: parseInt(value,10)});
        // return  species ? species.displayName : value;
        // return App.radio('collection').request('species:name', parseInt(value, 10));
        return value;
    },
});

module.exports = LocalityView;